import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicFontSize from "../DynamicFontSize";
export interface ContentFieldPropsType extends GeneralPropsType {}
function ContentField({
  children,
  className
}: ContentFieldPropsType) {
  return <DynamicFontSize fontSize={13} className={clsx(styles.container, styles.field, className)} data-sentry-element="DynamicFontSize" data-sentry-component="ContentField" data-sentry-source-file="index.tsx">
            {children}
        </DynamicFontSize>;
}
export default ContentField;